export default __webpack_public_path__ + "static/media/rackTrim2_Trim3.a3691ed4.mp4";